import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { AddUserResponseSchema } from '../types';

export type AddUserParams = {
	name: string;
	password: string;
	hasMultiLogin: boolean;
	note: string;
	role?: number;
	accountId: number;
};

export const createAddUserMutation = () =>
	createAuthMutation({
		params: declareParams<AddUserParams>(),
		request: {
			method: 'POST',
			url: '/user',
			body: (params) => params,
		},
		response: {
			contract: zodContract(AddUserResponseSchema),
		},
	});
